import { Component, OnInit, signal } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { AppMainComponent } from 'src/app/app.main.component';
import { RapportSST } from 'src/app/entites/rapport-sst';
import { Emplacement } from 'src/app/entites/emplacement';
import { DonneesBaseService } from 'src/app/services/donnees-base-service';
import { RapportSstService } from 'src/app/services/rapport-sst-service';
import { AjouterRapportJournalierSstComponent } from './controles/ajouter-rapport-journalier-sst.component';
import { CalendarMonthChangeEvent } from 'primeng/calendar';

@Component({
  selector: 'app-rapport-journalier-sst-calendar',
  templateUrl: './rapport-journalier-sst-calendar.component.html',
  providers: [DialogService]
})
export class RapportJournalierSSTCalendarComponent implements OnInit {
  currentDate: Date = new Date();
  selectedEmplacements: Emplacement[] = [];
  emplacements: Emplacement[] = [];
  rapportsByDate: { [key: string]: RapportSST[] } = {};
  loading = false;

  constructor(
    private sdb: DonneesBaseService,
    public router: Router,
    public messageService: MessageService,
    public appMain: AppMainComponent,
    public rapportSstService: RapportSstService,
    public dialogService: DialogService
  ) {
    this.emplacements = this.sdb.Emplacements();
  }

  ngOnInit() {
    this.loadMonthData();
  }

  loadMonthData() {
    this.loading = true;
    const firstDay = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), 1);
    const lastDay = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth() + 1, 0);

    // Reset the reports map
    this.rapportsByDate = {};

    this.rapportSstService.ObtenirPourMois(firstDay, lastDay, this.selectedEmplacements).subscribe({
      next: (data) => {
        // Group reports by date
        data.forEach(rapport => {
          const dateKey = new Date(rapport.date).toISOString().split('T')[0];
          if (!this.rapportsByDate[dateKey]) {
            this.rapportsByDate[dateKey] = [];
          }
          this.rapportsByDate[dateKey].push(rapport);
        });
        this.loading = false;
      },
      error: (error) => {
        this.messageService.add({ severity: 'error', summary: 'Erreur', detail: error.error });
        this.loading = false;
      }
    });
  }

  onMonthChange(event: CalendarMonthChangeEvent) {
    this.currentDate = new Date(event.year, event.month - 1, 1);
    this.loadMonthData();
  }

  onEmplacementChange() {
    if (this.selectedEmplacements.length > 10) {
      this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Vous ne pouvez pas sélectionner plus de 10 emplacements' });
      this.selectedEmplacements.splice(10);
      return;
    }
    this.loadMonthData();
  }

  getDayReports(date: any): RapportSST[] {
    const dateKey = new Date(date.year, date.month, date.day).toISOString().split('T')[0];
    return this.rapportsByDate[dateKey] || [];
  }

  onDateSelect(date: Date) {
    const reports = this.getDayReports(date);
    if (this.selectedEmplacements.length === 1 && reports.length === 0) {
      // Create new report for the selected emplacement
      this.router.navigate(['/assurancequalite/rapportjournalier/nouveau'], {
        queryParams: {
          date: date.toISOString().split('T')[0],
          emplacementId: this.selectedEmplacements[0].emplacementId
        }
      });
    } else if (this.selectedEmplacements.length === 1 && reports.length === 1) {
      // View the single report
      this.router.navigate(['/assurancequalite/rapportjournalier/' + reports[0].rapportSstId]);
    }
    // If multiple reports, do nothing as they are displayed in the calendar cell
  }

  getDay(date: any): string {
    return date.day + (date.day === new Date().getDate() && date.month === new Date().getMonth() && date.year === new Date().getFullYear() ? ' (Aujourd\'hui)' : '');
  }

  onReportClick(report: RapportSST) {
    this.router.navigate(['/assurancequalite/rapportjournalier/' + report.rapportSstId]);
  }

  nouveauRapportSST() {
    this.dialogService.open(AjouterRapportJournalierSstComponent, {
      header: 'Nouveau rapport SST',
      width: this.appMain.isMobile ? '100%' : '50%',
      height: this.appMain.isMobile ? '80%' : 'auto',
    });
  }
} 